// merge all type=file into a single type=multiplefiles
export const groupFiles = fields => {
  const fileList = {
    type: "multiplefiles",
    id: "formstackMultipleFiles",
    name: "formstackMultipleFiles",
    required: false,
    fieldIds: [],
  };
  const parsed = fields.map(field => {
    const { type, id, required } = field;
    if (type === "file") {
      fileList.fieldIds.push(id);
      fileList.required = fileList.required || required === "1";
      return fileList.fieldIds.length === 1 ? fileList : null;
    }

    return field;
  }).filter(field => field !== null);

  // we must convert the value back to a string as to remain consistent with the other fields being provided by the Formstack API.
  fileList.required = fileList.required ? "1" : "0";

  return parsed;
};
